import { Hero } from '../components/Hero';
import { Pains } from '../components/Pains';
import { Product } from '../components/Product';
import { Download } from '../components/Download';
import { Footer } from '../components/Footer';
import { BlogHeader } from '../components/BlogHeader';
import { Seo } from '../components/Seo';
import { SITE_URL, getStrings, localePath, altLinks, type Lang } from '../lib/i18n';
import { STORE_IOS, STORE_ANDROID } from '../lib/constants';

const appLd = {
  '@context': 'https://schema.org',
  '@type': 'MobileApplication',
  name: 'ArmProgress',
  alternateName: 'ArmProgress - Armwrestling Training App',
  applicationCategory: 'SportsApplication',
  operatingSystem: 'iOS 14.0+, Android 8.0+',
  aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.8', ratingCount: '1250', bestRating: '5', worstRating: '1' },
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'USD', availability: 'https://schema.org/InStock' },
  description:
    'A dedicated armwrestling training app built exclusively for pullers and armwrestlers. Track workouts, analyze performance with advanced analytics, monitor body measurements, and follow specialized training cycles.',
  downloadUrl: STORE_IOS,
  installUrl: STORE_ANDROID,
  softwareVersion: '2.0',
  creator: { '@type': 'Organization', name: 'MCDevLabs', url: 'https://www.mcdevlabs.com' },
};

const orgLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'ArmProgress',
  url: SITE_URL,
  logo: `${SITE_URL}/logo.png`,
  sameAs: [
    'https://www.facebook.com/people/ArmProgress/61585853075161/',
    'https://www.instagram.com/armprogress',
    'https://www.tiktok.com/@armprogress3',
    'https://t.me/armprogress',
    'https://www.youtube.com/@ArmProgressApp',
  ],
  contactPoint: { '@type': 'ContactPoint', contactType: 'Customer Support', url: `${SITE_URL}/contact.html` },
  parentOrganization: { '@type': 'Organization', name: 'MCDevLabs', url: 'https://www.mcdevlabs.com' },
};

export default function Home({ lang = 'en' as Lang }: { lang?: Lang }) {
  const t = getStrings(lang).hero;
  return (
    <div className="min-h-screen bg-dark">
      <Seo
        title={t.metaTitle}
        description={t.metaDescription}
        canonical={`${SITE_URL}${localePath(lang, '/')}`}
        jsonLd={[appLd, orgLd]}
        lang={lang}
        alternates={altLinks('/')}
      />
      <BlogHeader lang={lang} />
      <Hero lang={lang} />
      <Pains lang={lang} />
      <Product lang={lang} />
      <Download lang={lang} />
      <Footer lang={lang} />
    </div>
  );
}
